import { selectStyle } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";
import { useEffect, useRef, useState } from "react";

type Props = {
  chapter: string;
  label: string | JSX.Element;
  id?: string;
  onClick?: () => void;
  trigger?: Record<string, any>;
  term?: boolean;
};

//  @function ProductCard
//  Render a card component to display a title and a particular section
//  @param {string} chapter - chapter to be displayed on top of the card
//  @param {string} label - label or title of the card
//  @param {string} id - ID used to identify card
//  @param {function} label - function to be called when the card is clicked upon
//  @returns {React.Node}
export default function ProducerCard({
  chapter,
  label,
  id,
  onClick,
  trigger,
  term,
}: Props) {
  // TODO: Change from hardcoded colouring values to redux values;
  const { color2, color3, color4 } = useAppSelector(selectStyle);
  const producer = useAppSelector((state) => state.producer);
  const buttonRef = useRef<HTMLDivElement>(null);
  const [isSelected, setIsSelected] = useState(false);

  useEffect(() => {
    if (producer.selectedTrigger) {
      if (producer.selectedTrigger.trigger === trigger) {
        setIsSelected(true);
      } else {
        setIsSelected(false);
      }
    }
  }, [producer.selectedTrigger]);

  return (
    <div
      className="flex flex-col gap-2 px-2 py-4 min-w-22 max-w-[200px]  h-44 cursor-pointer flex-1 "
      style={
        isSelected
          ? { backgroundColor: color3, color: color2 }
          : { backgroundColor: color2, color: color3 }
      }
      id={id}
      ref={buttonRef}
      onClick={onClick}
      onMouseOver={() => {
        if (buttonRef.current) {
          buttonRef.current.style.background = color2;
          buttonRef.current.style.color = color2;
        }
      }}
      onMouseOut={() => {
        if (buttonRef.current && !isSelected) {
          buttonRef.current.style.background = color2;
          buttonRef.current.style.color = color2;
        }
      }}
    >
      <h3 className={`text-center text-xl pb-6 ${term ? "" : " truncate "}`}>
        {chapter}
      </h3>
      <div className="overflow-hidden -mt-6" style={{ color: color4 }}>
        {label}
      </div>
    </div>
  );
}
